module.exports = __webpack_public_path__ + "img/EZD_20210406_3.2167c6c4.png";